import PropTypes from 'prop-types';
import { Badge } from '@mantine/core';
import { IconTrendingUp, IconTrendingDown } from '@tabler/icons-react';

const DataAddOn = (props) => {
  const { type, data } = props;

  let content = null;
  if (type === 'array') {
    content = data?.length > 1 ? <Badge component="span" size="xs" variant="light" color="blue">{data.length - 1}+</Badge>
      : null;
  } else if (type === 'plusminus') {
    const color = data > 0 ? 'green' : 'red';

    if (data > 0) {
      content = <IconTrendingUp color={color} />;
    } else if (data < 0) {
      content = <IconTrendingDown color={color} />;
    } else {
      content = null;
    }
  }

  return content;
};

DataAddOn.propTypes = {
  type: PropTypes.string,
  data: PropTypes.any,
};

export default DataAddOn;
